/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_CheatingInputs */



/**
* | output |
* | --- |
* | "Cheating" |
*
* @param {Sanction_Sub_CheatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_cheating = /** @type {((inputs?: Sanction_Sub_CheatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_CheatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Triche")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trampa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Trapaça")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cheating")
	return /** @type {LocalizedString} */ ("Cheating")
});